module.exports = __webpack_public_path__ + "img/coordinate.52bc3055.png";